<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="m-0" [ngStyle]="{'background-color':data|notificationColor}">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">
            <mat-icon>{{data|notificationIcon}}</mat-icon>
            {{title}}
          </span>
      <button mat-icon-button (click)="close()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-16 m-12">
    {{message}}
  </div>

  <div mat-dialog-actions class="m-0 px-16 pb-16" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-raised-button (click)="close()" aria-label="CLOSE">CLOSE</button>
  </div>
</div>
